import { Button, Modal } from 'semantic-ui-react';

type MappingsSaveModalPropsType = {
    open: boolean;
    onClose: () => void;
    handleSave: () => void;
};
const MappingsSaveModal = ({ open, onClose, handleSave }: MappingsSaveModalPropsType) => {
    return (
        <Modal size="mini" open={open} onClose={onClose}>
            <Modal.Header>Save Mappings</Modal.Header>
            <Modal.Content>
                <p>This will affect the import table!</p>
                <p>Previously made changes to import table may be lost!</p>
            </Modal.Content>
            <Modal.Actions>
                <Button positive onClick={handleSave}>
                    SAVE
                </Button>
                <Button secondary onClick={onClose}>
                    CANCEL
                </Button>
            </Modal.Actions>
        </Modal>
    );
};

export default MappingsSaveModal;
